import React from "react";
import styles from "./Home.module.css";

// White card with a title, an optional grey subtitle and count pill, and a slot for tools on the right.
export default function Panel({ title, sub, count, countTone, tools, children }) {
  return (
    <section className={styles.panel}>
      <header className={styles.panelHead}>
        <h2>{title}</h2>
        {sub && <span className={styles.panelSub}>{sub}</span>}
        {count != null && <span className={`${styles.count} ${countTone === "neutral" ? styles.countNeutral : ""}`}>{count}</span>}
        {tools && <div className={styles.panelTools}>{tools}</div>}
      </header>
      {children}
    </section>
  );
}
